import { ENV } from "constant/app";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { Table, Column } from "ui/table";
import { Box } from "view/layout/box";

const { APP_NAME } = ENV;

class StrategyTable extends React.PureComponent {
  static get propTypes() {
    return {
      stats: PropTypes.array.isRequired,
    };
  }

  constructor() {
    super();
  }

  _formatName(cell, row) {
    if (!row.id) {
      return "No Strategy";
    }
    if (APP_NAME === "zeus") {
      return cell;
    }
    return <Link to={`/v2/strategies/${row.id}/edit`}>{cell}</Link>;
  }

  _formatPlayerCount(cell, row) {
    if (!row.id || APP_NAME === "zeus") {
      return cell;
    }
    const q = `strategy_name: "${encodeURIComponent(row.name)}"`;
    return (
      <Link to={`/devices?q=${q}`} title={`Devices for ${row.name}`}>
        {cell}
      </Link>
    );
  }

  render() {
    const { stats } = this.props;

    return (
      <Box title="Strategy Stats">
        <Table
          data={stats}
          defaultSorted={[{ dataField: "count", order: "desc" }]}
          hover={true}
          keyField="name"
          pagination={true}
        >
          <Column
            key="name"
            dataField="name"
            isKey={true}
            dataSort={true}
            dataFormat={this._formatName}
          >
            Name
          </Column>
          <Column
            key="count"
            dataField="count"
            dataFormat={this._formatPlayerCount}
            dataSort={true}
          >
            Player Count
          </Column>
        </Table>
      </Box>
    );
  }
}

export { StrategyTable };
